import React, { useState } from "react";
import { Sheet } from "react-modal-sheet";

const BottomSheet = ({ children, isOpen, onClose, snapPoint = 400 }) => {

  return (
      <Sheet isOpen={isOpen} onClose={onClose} snapPoints={[snapPoint]}>
        <Sheet.Container>
          <Sheet.Header />
          <Sheet.Content>
            <div className="alert">
              <button onClick={onClose} type="button" className="btn-close" aria-label="Close"></button>
              {children}
            </div>
          </Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop />
      </Sheet>
  );
};

export default BottomSheet;
